import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Dialog',

  mixins: [ proxy() ],

  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
